import { useCookies } from 'react-cookie'

import { canaryCookieKey } from 'pages/_document'

export const useCanary = () => {
  const [{ [canaryCookieKey]: canaryEnabled }] = useCookies([canaryCookieKey])

  return canaryEnabled === '1'
}
